module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.appClass,
    on: {
      "click": _vm.clickOff
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_vm._m(0), _c('div', {
    key: this.report,
    staticClass: "current-client"
  }, [_c('div', {
    class: _vm.setClientContainerClass()
  }, [_c('span', {
    staticClass: "current-client__label"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.currentClient')))]), _vm._v(" "), _c('span', {
    staticClass: "current-client__val"
  }, [_vm._v(_vm._s(_vm.getClientName()))])]), _vm._v(" "), _c('div', {
    class: _vm.setClientContainerClass()
  }, [_c('span', {
    staticClass: "current-client__label"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.currentView')))]), _vm._v(" "), _c('span', {
    staticClass: "current-client__val"
  }, [_vm._v(_vm._s(_vm.getCurrentView()))]), _vm._v(" "), _c('button', {
    staticClass: "current-client__link",
    on: {
      "click": function($event) {
        _vm.setView('snapshots')
      }
    }
  }, [_vm._v("(change)")])])]), _c('ul', {
    staticClass: "toolbar"
  }, [_c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('client'),
    on: {
      "click": function($event) {
        _vm.setView('client')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "client"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.clientPanelButton')))])], 1)]), _c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('load'),
    on: {
      "click": function($event) {
        _vm.startAction('load')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "load"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.clientLoadButton')))])], 1)]), _c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('print'),
    on: {
      "click": function($event) {
        _vm.openPrint('print')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "print"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.printButton')))])], 1)]), _c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('tools'),
    on: {
      "click": function($event) {
        _vm.setView('tools')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "tools"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.toolsButton')))])], 1)]), _c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('settings'),
    on: {
      "click": function($event) {
        _vm.setView('settings')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "settings"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.settingsButton')))])], 1)]), _c('li', {
    staticClass: "toolbar__item"
  }, [_c('button', {
    class: _vm.setToolButtonClass('logout'),
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "logout"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "toolbar__item-tip"
  }, [_vm._v(_vm._s(_vm._translate('toolbar.logoutButton')))])], 1)])])]), _vm._v(" "), _c('div', {
    key: this.key,
    staticClass: "app__canvas"
  }, [_c('div', {
    staticClass: "report-background",
    style: (_vm.setBackground)
  }), _vm._v(" "), (_vm.hasClient()) ? _c('Panel', {
    attrs: {
      "context": "client",
      "tabs": "client",
      "align": "left",
      "sub": "true",
      "width": "2",
      "subwidth": "1",
      "save": "saveClient"
    }
  }) : _vm._e(), _vm._v(" "), _c('Panel', {
    attrs: {
      "context": "load",
      "align": "left",
      "width": "2"
    }
  }), _vm._v(" "), _c('Panel', {
    attrs: {
      "context": "tools",
      "align": "right",
      "sub": "true",
      "width": "4",
      "subwidth": "x3",
      "controller": "tools"
    }
  }), _vm._v(" "), _c('Panel', {
    attrs: {
      "context": "settings",
      "tabs": "settings",
      "sub": "true",
      "align": "right",
      "width": "3",
      "subwidth": "x2",
      "save": "saveConstants"
    }
  }), _vm._v(" "), _c('Panel', {
    attrs: {
      "context": "snapshots",
      "sub": "true",
      "align": "left",
      "width": "4",
      "subwidth": "x3",
      "save": "saveSnapshots"
    },
    on: {
      "updateApp": _vm.updateApp
    }
  }), _vm._v(" "), _c('div', {
    key: this.report,
    class: _vm.setReportsClass,
    attrs: {
      "id": "app-reports"
    }
  }, [(_vm.hasClient()) ? _c('ul', {
    staticClass: "report-tabs"
  }, [_c('li', {
    class: _vm.setReportTabClass('networth')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveReport('networth', true)
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('report.netWorth')))])]), _c('li', {
    class: _vm.setReportTabClass('retirementplanner')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveReport('retirementplanner', true)
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('report.retirementPlanner')))])]), _c('li', {
    class: _vm.setReportTabClass('financialgps')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveReport('financialgps', true)
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('report.financialGPS')))])]), (_vm.isDevMode()) ? _c('li', {
    class: _vm.setReportTabClass('test')
  }, [_c('button', {
    staticClass: "report-tabs__button",
    on: {
      "click": function($event) {
        _vm.setActiveReport('test', true)
      }
    }
  }, [_vm._v("Dev")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app__report-wrap",
    attrs: {
      "id": "app-reports-wrap"
    }
  }, [(this.$data.report === 'start') ? _c('div', {
    staticClass: "start-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm._translate('welcome.introQuestion')))]), _vm._v(" "), _c('div', {
    staticClass: "start-block__actions"
  }, [_c('div', {
    staticClass: "start-block__action"
  }, [_c('div', {
    staticClass: "start-block__action-inner"
  }, [_c('div', {
    staticClass: "start-block__action-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.startAction('new')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "add"
    }
  }), _vm._v("\n                    " + _vm._s(_vm._translate('welcome.add')) + "\n                  ")], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "start-block__action"
  }, [_c('div', {
    staticClass: "start-block__action-inner"
  }, [_c('div', {
    staticClass: "start-block__action-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.startAction('load')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "load"
    }
  }), _vm._v("\n                    " + _vm._s(_vm._translate('welcome.load')) + "\n                  ")], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.hasClient()) ? _c('div', [_c('div', {
    class: _vm.setReportClass('networth', true)
  }, [_c('NetWorth')], 1), _vm._v(" "), _c('div', {
    class: _vm.setReportClass('retirementplanner', true)
  }, [_c('RetirementPlanner')], 1), _vm._v(" "), _c('div', {
    class: _vm.setReportClass('financialgps', true)
  }, [_c('FinancialGPS')], 1), _vm._v(" "), (_vm.isDevMode() && _vm.hasClient()) ? _c('div', {
    class: _vm.setReportClass('test')
  }, [_c('Developer')], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('a', {
    class: _vm.setBacktoTopClass(),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "chevron-down"
    }
  })], 1)])], 1), _vm._v(" "), _c('Modal'), _vm._v(" "), _c('div', {
    class: _vm.getErrorClass()
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getErrorMessage())
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "app-loading",
    style: ({
      'background-image': 'url(\'img/loading.svg\')'
    })
  }, [_vm._v(_vm._s(_vm._translate('working.text')) + "…")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "ctx"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo__image",
    attrs: {
      "src": "brand/rose-logo.png",
      "alt": "Rose & Associates Logo"
    }
  }), _c('span', {
    staticClass: "logo__text"
  }, [_vm._v("Rose & Associates")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65524315!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 325
// module chunks = 0